import { Row, Col, Card } from 'react-bootstrap'
import { FaPen } from "react-icons/fa"
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import CatTable from '../../../components/catalogos/CatTable';
import { getActive } from '../../../utils/getActive';
import Put from '../../../api/Put';
import { MUNICIPIO_UPDATE } from '../../../api/Routes';

function MunicipioList({items, editar, auth, loadToEdit}){
    const actions = (cell, row) => <BootstrapSwitchButton
        checked={getActive(row, auth.data.company)} 
        onlabel="Activo"
        onstyle="success"
        offlabel="Inactivo"
        offstyle="danger"
        width={69}
        size="sm"
        onChange={(value)=>editar({...row, "active":`${value}`})
        }
    />
    const name = (cell, row) => <Row>
        <Col xs="6" sm="6" md="6" lg="6" xl="6">
            {row.dsMunDel}
        </Col>
        <Col xs="6" sm="6" md="6" lg="6" xl="6" className="section-edit">
            <FaPen className='iconAction colorNaranja float-right' onClick={e=>loadToEdit(row)}/>
        </Col>
    </Row>
        
        const columns = [
            {
                text: 'ID',
                dataField: 'id',
                hidden:true
            },
            {
                text: 'Código',
                dataField: 'codMD',
                headerStyle: { width: '20%' }
            },  
            {
                text: 'NOMBRE',
                dataField: 'dsMunDel',
                formatter: name,
                headerStyle: { width: '70%' },
            },  {
                dataField: '',
                isDummyField: true,
                text: 'ACCIONES',
                headerStyle: {  width: '10%', },
                formatter: actions,
                editable:false,
            }
        ]
    
        return (<>
            <Card className="shadow-1 mt-3">
                <Card.Body>
                    <CatTable 
                        columns={columns} 
                        items={items}
                        noEdit={true}
                    />
                </Card.Body>
            </Card>
        </>)

}

export default MunicipioList